(function () {
    'use strict';

    function configurationDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/siteconfigurations';

        function loadConfiguration(id) {
            return $http.get(baseUrl + '/' + id).then(function (response) {
                return response.data;
            });
        };

        function loadSearchFieldConfigurations(id, entityType) {
            return $http.get(baseUrl + '/' + id + '/entities/' + entityType + '/searchfields').then(function (response) {
                return response.data;
            });
        };

        function loadAllConfigurations() {
            return $http.get(baseUrl).then(function (response) {
                return response.data;
            });
        };

        function createConfiguration(data) {
            return $http.post(baseUrl, data).then(function (response) {
                return response.data;
            });
        }

        function saveConfiguration(id, data) {
            return $http.put(baseUrl + '/' + id, data).then(
                function (response) { return true; }
            );
        };

        return {
            loadConfiguration: loadConfiguration,
            loadSearchFieldConfigurations: loadSearchFieldConfigurations,
            loadAllConfigurations: loadAllConfigurations,
            createConfiguration: createConfiguration,
            saveConfiguration: saveConfiguration
        };
    }

    configurationDataService.$inject = ['$http'];

    angular.module('ecap.siteConfiguration').service('configurationDataService', configurationDataService);
})();
